/**
 * Contains all weather page components.
 */

import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';
import WeatherPage from 'components/weather';
import WeatherAlerts from 'components/weather/alerts';
import WeatherRadar from 'components/weather/radar';
import CurrentConditions from 'components/weather/currentConditions';
import HourlyForecast from 'components/weather/hourlyForecast';
import TenDayForecast from 'components/weather/tenDayForecast';
import VideoForecast from 'components/weather/videoForecast';
import IframeConditions from 'components/weather/iframeConditions';

import 'scss/weather/index.scss';
import 'scss/cards/index.scss';

domContentLoaded(() => {
  reactComponentManager({
    CurrentConditions,
    HourlyForecast,
    TenDayForecast,
    WeatherPage,
    WeatherAlerts,
    WeatherRadar,
    VideoForecast,
    IframeConditions,
  });
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    CurrentConditions,
    HourlyForecast,
    TenDayForecast,
    WeatherPage,
    WeatherAlerts,
    WeatherRadar,
    VideoForecast,
    IframeConditions,
  });
}
